import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';

import { FacilityInfo } from '../services/models';
import { SupportService } from '../services';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable()
export class ResolveFacilityInfoGuard implements Resolve<FacilityInfo> {
  constructor(private contactUsService: SupportService) { }

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): FacilityInfo | Observable<FacilityInfo> | Promise<FacilityInfo> {
    return this.contactUsService
      .getPrimaryFacilityInfo()
      .pipe(map(facilityInfoArr => facilityInfoArr[0]));
  }
}
